import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';

class MainNav extends Component {
  constructor (props) {
    super(props);
    this.state = {
      mobileMenu: false
    };
    this.toggleSiteNav = this.toggleSiteNav.bind(this);
    this.navClicked = this.navClicked.bind(this);
  }
  toggleSiteNav (e) {
    this.setState({
      mobileMenu: (this.state.mobileMenu !== true)
    });
    e.preventDefault();
    // $("html").toggleClass("overlay-is-visible site-nav-is-open");
    // document.documentElement.style
    document.body.classList.toggle('overlay-is-visible', this.state.mobileMenu);
    document.body.classList.toggle('site-nav-is-open', this.state.mobileMenu);
    return false;
  }
  navClicked (e) {
    if (this.state.mobileMenu) {
      document.body.classList.toggle('overlay-is-visible', false);
      document.body.classList.toggle('site-nav-is-open', false);
    }
  }
  render () {
    return (
      <nav>
        <ul className='site-nav'>
          <li onClick={this.toggleSiteNav}><NavLink to='/tour' activeClassName='is-active'>How it works</NavLink></li>
          <li onClick={this.toggleSiteNav}><NavLink to='/courses' activeClassName='is-active'>Courses</NavLink></li>
          <li onClick={this.toggleSiteNav}><NavLink to='/contact' activeClassName='is-active'>Contact</NavLink></li>
          <li><a href='https://app.bslcourses.co.uk'>Log in</a></li>
          <li onClick={this.toggleSiteNav}><Link to='/get-started' className='button button--outline button--s'>Get started</Link></li>
        </ul>
        <a onClick={this.toggleSiteNav} className='site-nav-toggle burger-button js-site-nav-toggle'>
          <div onClick={this.toggleSiteNav} className='bar' />
          <span className='u-sr-only'>Menu</span>
        </a>
      </nav>
    );
  }
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/MainNav/index.js